import { DsText } from "@mvp/design-system";
import React from "react";
import { PhoneNumber } from "../../PhoneNumber";
import { ContentTitle } from "./ContentTitle";
import { modalText } from "./modalText";

export const UnderNineteenContent: React.FC = () => {
  return (
    <>
      <ContentTitle text={modalText.callToComplete} />
      <DsText variant="body1">
        {modalText.under19.part1}
        {modalText.under19.part2}
        <PhoneNumber
          variant="body1"
          phoneNumber={modalText.phoneNumber}
        />
        {modalText.thankYou}
      </DsText>
    </>
  );
};
